import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  muleTokenBiometric,
  onBiometrics,
  onResetPassword,
  signIn,
} from '/redux/action/auth.action';
import {credentialsEmail} from '/redux/selector/auth.selector';
import {autoLoginState} from '/redux/selector/biometrics.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {getLoadingState} from '/redux/selector/loading.selector';
import {isConnected} from '/redux/selector/network.selector';
import {withProps} from '/util/selector.util';

import LoginForm from './LoginForm';
interface StateProps {
  isNetworkConnected: boolean;
  email: string;
  isLoading: boolean;
  shouldAutoLogin: boolean;
  lastPaidRank: string;
}
interface DispatchProps {
  onSignIn: (username: string, password: string) => void;
  onBiometrics: (username: string, refresh_token: string) => void;
  muleTokenBiometric: (refresh_token: string) => void;
  onResetPassword: (email: string) => void;
}
const mapStateToProps = createStructuredSelector({
  isNetworkConnected: isConnected,
  email: credentialsEmail,
  isLoading: getLoadingState,
  shouldAutoLogin: autoLoginState,
  userId,
  lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  onSignIn: (username: string, password: string) =>
    dispatch(signIn({username, password})),
  onBiometrics: (username: string, refresh_token: string) =>
    dispatch(onBiometrics({username, refresh_token})),
  muleTokenBiometric: (refresh_token: string) =>
    dispatch(muleTokenBiometric({refresh_token})),
  onResetPassword: (email: string) => dispatch(onResetPassword({email})),
});

const LoginFormConnected = connect<StateProps, DispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(LoginForm);

export {LoginFormConnected as LoginForm};
